
import { Vue, Component, Watch } from "vue-property-decorator";
import corpService from "@/store/common/module/CorpService";
import TariffManager from "@/views/tariff_new/TariffManager.vue";
import { VueEditor, Quill } from "vue2-editor";

@Component({
  components: {
    VueEditor,
    Quill,
    TariffManager,
  },
})
export default class Demo extends Vue {
  tariff = null;
  @Watch("tariff")
  asdd() {
    console.log(this.tariff);
  }
  name = "";
  menu1 = false;
  country = "";
  garage = "";
  city = "";
  on = null;
  page = 1;
  customer = null;
  client = null;
  clients = [];
  vehicleType = null;
  vendors = [];
  vendor = null;
  rate = null;
  bu = null;
  ownBu = null;
  isd = null;
  state = null;
  cityGroup = null;
  currency = ["INR"];
  language = null;
  date = null;
  time = null;
  roles = null;
  content = null;
  address = null;
  vehicle = "";
  driver = "";
  campus = null;
  month = 201811;
  pump = null;
  zone = null;

  customerSelected(customer) {
    this.customer = customer;
  }

  onRateSelect(rate) {
    this.rate = rate;
  }

  clearClients() {
    corpService.clearClients();
  }
}
